var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4186 5.33337C17.6986 5.33337 5.75195 17.28 5.75195 32C5.75195 46.72 17.6986 58.6667 32.4186 58.6667C47.1386 58.6667 59.0853 46.72 59.0853 32C59.0853 17.28 47.1386 5.33337 32.4186 5.33337ZM25.752 39.12V24.88C25.752 22.7734 28.0986 21.4934 29.8586 22.64L40.9253 29.76C42.5519 30.8 42.5519 33.2 40.9253 34.24L29.8586 41.36C28.0986 42.5067 25.752 41.2267 25.752 39.12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.6ed233c6ec1bed2ea57cb03af34fe8ec.svg";
export { ForwardRef as ReactComponent };